import React from "react";
import { connect } from "react-redux";
import {
  Breadcrumb,
  Button, Divider,
  Dropdown,
  Grid,
  GridColumn,
  GridRow,
  Icon,
  Popup,
  Input,
  Label,
} from "semantic-ui-react";
import moment from "moment";
import {getClipFilesBySearch, geAssetFolderByID} from "../../services/assetService";
import {
  getClipAssetFile, getClipFolder, addClipAssetFile, addClipFolder, editAssetFile, deleteAssetFile, editAssetFolder, deleteAssetFolder
} from "../../actions/assetsActions";
import { downloadFile, getIconBasedOnFile, getShareFolderLink } from "../../utility";
import AddFolder from '../AddAssetsFolder';
import AddFile from '../AddAssetsFile';
import EditMedia from '../EditAssetsMedia';
import DownloadAs from "../DownloadAs";
import Snackbar from "../Snackbar";
import {ConfirmModal} from "../CustomModal";

import "../../containers/home.css";

class Clips extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      openAddFolder: false,
      openAddFile: false,
      openDownloadAs: false,
      openDeleteFile: false,
      openDeleteFolder: false,
      fileName: null,
      downloadURL: null,
      folderID: null,
      folderForAction: null,
      fileForAction: null,
      editNamePopup: null,
      editName: null,
      folderPath: [{
        folder_id: null,
        name: 'Home'
      }],
      snackbar: {
        open: false,
        message: '',
        success: false,
        error: false
      },
      isSearchLoading: false,
      searchResults: [],
      searchValue: '',
    };
  }

  componentDidMount() {
    const folder = new URLSearchParams(this.props.location.search).get("folder");
    if(folder) {
      geAssetFolderByID(folder, "clip")
      .then(data => {
        if(data.data.length) {
          this.handleFolderClick(folder, data.data[0].name);
        } else {
          this.setState({
            snackbar: {
              open: true,
              message: 'Folder you are looking for is not found!',
              success: false,
              error: true
            }
          })
        }
      }).catch(err => {
        this.setState({
          snackbar: {
            open: true,
            message: 'Unable to find folder!',
            success: false,
            error: true
          }
        })
      })
    } else {
      const { fetchClipAssetFile, fetchClipFolder } = this.props;
      fetchClipAssetFile(null);
      fetchClipFolder(null);
    }
  }

  changeFolder = (folderID, index) => {
    const { fetchClipAssetFile, fetchClipFolder } = this.props;
    this.setState(state => ({
      ...state,
      folderID,
      folderPath: state.folderPath.filter((_, i) => i <= index)
    }), () => {
      fetchClipAssetFile(folderID);
      fetchClipFolder(folderID)
    });
  }

  handleFolderClick = (folder_id, name) => {
    const { fetchClipAssetFile, fetchClipFolder } = this.props;
    this.setState(state => ({
      ...state,
      folderID: folder_id,
      folderPath: [...state.folderPath, {folder_id, name}]
    }), () => {
      fetchClipAssetFile(folder_id);
      fetchClipFolder(folder_id);
    });
  }

  resetSnackbar = () => {
    this.setState({
      snackbar: {
        open: false,
        message: '',
        success: false,
        error: false
      }
    })
  }

  handleSearchChange = (e, { value }) => {
    this.setState({ searchValue: value, searchResults: [] });
    let searchValue = value.trim();
    if (searchValue.length > 2) {
      this.setState({isSearchLoading: true});
      getClipFilesBySearch(searchValue)
      .then(data => {
        this.setState({
          isSearchLoading: false,
          searchResults: data.data.map((x, i) => ({title: x.name, key: x.name+i, ...x})),
        });
      }).catch(err => {
        this.setState({isSearchLoading: false});
      })
    }
  }

  shareFolderLink = ({id}) => {
    navigator.clipboard.writeText(getShareFolderLink(id, "clips"));
    this.setState({
      snackbar: {
        open: true,
        message: 'Copied to clipboard!',
        success: true,
        error: false
      }
    });
  }

  confirmDeleteFile = () => {
    const {deleteFile} = this.props;
    const {fileForAction} = this.state;
    deleteFile(fileForAction, "clip")
      .then(() => {
        this.setState({
          fileForAction: null, editName: null, openDeleteFile: false,
          snackbar: {
            open: true,
            message: 'File Deleted!',
            success: true,
            error: false
          }
        });
      })
      .catch(err => {
        this.setState({
          fileForAction: null, editName: null, openDeleteFile: false,
          snackbar: {
            open: true,
            message: err.data && err.data.message,
            success: false,
            error: true
          }
        })
      });
  }

  confirmDeleteFolder = () => {
    const {deleteFolder} = this.props;
    const {folderForAction} = this.state;
    deleteFolder([folderForAction], "clip")
      .then(() => {
        this.setState({
          folderForAction: null, editName: null, openDeleteFolder: false,
          snackbar: {
            open: true,
            message: 'Folder Deleted!',
            success: true,
            error: false
          }
        });
      })
      .catch(err => {
        this.setState({
          folderForAction: null, editName: null, openDeleteFolder: false,
          snackbar: {
            open: true,
            message: err.data && err.data.message,
            success: false,
            error: true
          }
        })
      });
  }

  render() {
    const {
      fileName, downloadURL, folderID, folderPath, snackbar, isSearchLoading, searchResults, searchValue, openDownloadAs, openAddFolder, openAddFile,
      openDeleteFile, openDeleteFolder, folderForAction, fileForAction, editNamePopup, editName,
    } = this.state;
    const { assetsLoading, files, folders, addFile, addFolder, updateFile, updateFolder, authID } = this.props;
    let searchLength = searchValue.length;
    let searchResultLength = searchResults.length;
    return (
      <>
        <Grid className="home-container">
          <GridColumn
            className="main-col"
            mobile={16}
            tablet={12}
            computer={16}
          >
            <div className="main-details" style={{ height: "100%" }}>
              <center>
                <h1>Clips</h1>
              </center>
              <div className="d-flex justify-content-between align-items-center mb-2">
                <Dropdown className="btn-dropdown"
                  closeOnBlur
                  closeOnEscape
                  closeOnChange
                  icon
                  trigger={<span><Icon name="plus" color="blue"/> New</span>}
                  style={{margin: '1px 10px 1px 1px'}}
                >
                  <Dropdown.Menu>
                    <Dropdown.Item icon="folder" text='New Folder' onClick={() => this.setState({openAddFolder: true})}/>
                    <Dropdown.Item icon="file" text='File Upload' onClick={() => this.setState({openAddFile: true})}/>
                  </Dropdown.Menu>
                </Dropdown>
                <Input
                  className='search-file'
                  icon='search'
                  iconPosition='left'
                  loading={isSearchLoading}
                  onChange={this.handleSearchChange}
                  value={searchValue}
                  placeholder='Please type 3 or more characters to serach file!'
                />
              </div>
              <Divider/>
              <Breadcrumb size="huge" className="custom-breadcrumb">
              {
                folderPath.map((f, i) => <>
                  <Breadcrumb.Section
                    key={i}
                    active={i === folderPath.length - 1}
                    link
                    onClick={() => this.changeFolder(f.folder_id, i)}
                  >
                    <span className="unselectable">{f.name}</span>
                  </Breadcrumb.Section>
                  {
                    i !== folderPath.length - 1 && <Breadcrumb.Divider icon='right chevron'/>
                  }
                  {
                    f.name !== 'Home' && i === folderPath.length - 1 &&
                    <Button
                    basic
                    circular
                    icon='share'
                    size='mini'
                    title={`Copy Link of ${f.name} Folder`}
                    onClick={() => this.shareFolderLink({id: f.folder_id, ...f})}
                    />
                  }
                </>)
              }
              </Breadcrumb>
              <Divider/>
              {
                searchLength > 2 && searchResultLength > 0 && !isSearchLoading && <>
                  <h2 className="header">Search Result ({searchResultLength})</h2>
                  <Grid className="w-100 m-0" columns={3}>
                    <GridRow>
                      {searchResults.map((f) => (
                          <GridColumn
                            mobile={16}
                            tablet={5}
                            computer={3}
                            key={f.id}
                          >
                            {
                              f.total_used > 0 &&
                              <Label size="small" color="grey" circular title={`Used ${f.total_used} times`} className="label-left-floating">
                                { f.total_used }
                              </Label>
                            }
                            <Button
                              className={`file-btn w-100 ${authID === f.user_id ? 'owned' : ''}`}
                              basic
                              onDoubleClick={() =>
                                window.open(f.access_url, "_blank")
                              }
                            >
                              <div>
                                <div className="file-img">
                                {
                                  f.thumbnail !== null
                                    ? <img src={`https://d2a39xd6ecmbf2.cloudfront.net/drive/thumbnail/${f.thumbnail}`} height='150' width='250'/>
                                    : <Icon name={getIconBasedOnFile(f.name)}/>
                                }
                                </div>
                                <div className="d-flex text-truncate file-name">
                                  <Popup
                                    trigger={
                                      <span className="text-truncate text-left">
                                        {f.name}
                                      </span>
                                    }
                                    inverted
                                    hideOnScroll
                                  >
                                    <div>Name: {f.name}</div>
                                    <div>
                                      Created At:
                                      {moment(f.created).format(
                                        " YYYY-MM-DD HH:mm:ss"
                                      )}
                                    </div>
                                    {f.modified && (
                                      <div>
                                        Last Modified At:
                                        {moment(f.modified).format(
                                          " YYYY-MM-DD HH:mm:ss"
                                        )}
                                      </div>
                                    )}
                                  </Popup>
                                  <div className="folder-action">
                                    <Dropdown
                                      key={`dropdown-${f.id}`}
                                      simple
                                      closeOnBlur
                                      closeOnEscape
                                      closeOnChange
                                      direction="left"
                                      icon={
                                        <Icon
                                          size="small"
                                          name="ellipsis vertical"
                                        />
                                      }
                                    >
                                      <Dropdown.Menu>
                                        <Dropdown.Item
                                          onClick={() =>
                                            window.open(f.access_url, "_blank")
                                          }
                                        >
                                          <Icon name="arrow up" color="blue" />
                                          Open
                                        </Dropdown.Item>
                                        {
                                          f.folder_id &&
                                          <Dropdown.Item
                                            onClick={() =>
                                              window.open(getShareFolderLink(f.folder_id, 4))
                                            }
                                          >
                                            <Icon name="arrow right" color="blue" />
                                            Open Folder
                                          </Dropdown.Item>
                                        }
                                        <Dropdown.Item onClick={() => {
                                          navigator.clipboard.writeText(f.access_url)
                                          this.setState({
                                            snackbar: {
                                              open: true,
                                              message: 'Copied to clipboard!',
                                              success: true,
                                              error: false
                                            }
                                          });
                                        }}>
                                          <Icon name="copy outline" color="blue"/>
                                          Copy Link
                                        </Dropdown.Item>
                                        <Dropdown.Item
                                          onClick={() =>
                                            downloadFile(f.access_url, f.name)
                                          }
                                        >
                                          <Icon name="download" color="blue" />
                                          Download
                                        </Dropdown.Item>
                                        <Dropdown.Item
                                          onClick={() =>
                                            this.setState({
                                              openDownloadAs: true,
                                              fileName: f.name,
                                              downloadURL: f.access_url,
                                            })
                                          }
                                        >
                                          <Icon name="download" />
                                          Download As
                                        </Dropdown.Item>
                                        {
                                          authID === f.user_id &&
                                          <>
                                            <Dropdown.Item
                                              onClick={() =>
                                                this.setState({editNamePopup: true, editName: f.name, fileForAction: f.id})
                                              }
                                            >
                                              <Icon name="edit" color="blue"/>
                                              Edit File
                                            </Dropdown.Item>
                                            <Dropdown.Item
                                              onClick={() =>
                                                this.setState({fileForAction: f.id, editName: f.name, openDeleteFile: true})
                                              }
                                            >
                                              <Icon name="trash alternate outline" color="red"/>
                                              Delete
                                            </Dropdown.Item>
                                          </>
                                        }
                                      </Dropdown.Menu>
                                    </Dropdown>
                                  </div>
                                </div>
                              </div>
                            </Button>
                          </GridColumn>
                        ))}
                    </GridRow>
                  </Grid>
                </>
              }
              <h2 className="header">Folders</h2>
              <Grid className="w-100 m-0" columns={3}>
                <GridRow>
                  {assetsLoading ? (
                    <div className="d-flex w-100 justify-content-center text-light">
                      Loading...
                    </div>
                  ) : folders.length > 0 ? (
                    folders.map((f) => (
                      <GridColumn key={f.id} mobile={16} tablet={5} computer={3}>
                        {
                          f.total_used > 0 &&
                          <Label size="small" color="grey" circular title={`Used ${f.total_used} times`} className="label-left-floating">
                            { f.total_used }
                          </Label>
                        }
                        <div
                          className={`folder-btn w-100 ui basic button ${authID === f.user_id ? 'owned' : ''}`}
                          onClick={
                            (e) => {
                              if (e.ctrlKey) this.handleFolderClick(f.id, f.name)
                            }
                          }
                          onDoubleClick={() => {
                            this.handleFolderClick(f.id, f.name)
                          }}
                        >
                          <div className="d-flex text-truncate">
                            <Icon name='folder'/>
                            <Popup
                              trigger={<span className="text-truncate text-left">{f.name}</span>}
                              inverted
                              hideOnScroll
                            >
                              <div>Name: {f.name}</div>
                              <div>Created At: {moment(f.created).format('YYYY-MM-DD HH:mm:ss')}</div>
                              { f.modified && <div>Last Modified At: {moment(f.modified).format('YYYY-MM-DD HH:mm:ss')}</div> }
                            </Popup>
                            <div className="folder-action">
                              <Dropdown
                                key={`dropdown-${f.id}`}
                                simple
                                closeOnBlur
                                closeOnEscape
                                closeOnChange
                                direction='left'
                                icon={<Icon size="small" name="ellipsis vertical"/>}
                              >
                                <Dropdown.Menu>
                                  <Dropdown.Item onClick={() => this.handleFolderClick(f.id, f.name)}>
                                    <Icon name="arrow up" color="blue"/>
                                    Open
                                  </Dropdown.Item>
                                  <Dropdown.Item onClick={() => this.shareFolderLink(f)}>
                                    <Icon name="copy outline" color="blue"/>
                                    Copy Link
                                  </Dropdown.Item>
                                  {
                                    authID === f.user_id &&
                                      <>
                                        <Dropdown.Item
                                          onClick={
                                            () => this.setState({
                                              editNamePopup: true,
                                              editName: f.name,
                                              folderForAction: f.id
                                            })
                                          }
                                        >
                                          <Icon name="edit" color="blue"/>
                                          Edit Folder
                                        </Dropdown.Item>
                                        <Dropdown.Item
                                          onClick={() =>
                                            this.setState({folderForAction: f.id, editName: f.name, openDeleteFolder: true})
                                          }
                                        >
                                          <Icon name="trash alternate outline" color="red"/>
                                          Delete
                                        </Dropdown.Item>
                                      </>
                                  }
                                </Dropdown.Menu>
                              </Dropdown>
                            </div>
                          </div>
                        </div>
                      </GridColumn>
                    ))
                  ) : (
                    <div className="d-flex w-100 justify-content-center text-light">
                      No Folders
                    </div>
                  )}
                </GridRow>
              </Grid>
              <h2 className="header">Files</h2>
              <Grid className="w-100 m-0" columns={3}>
                <GridRow>
                  {assetsLoading ? (
                    <div className="d-flex w-100 justify-content-center text-light">
                      Loading...
                    </div>
                  ) : files.length > 0 ? (
                    files.map((f) => (
                      <GridColumn
                        mobile={16}
                        tablet={5}
                        computer={3}
                        key={f.id}
                      >
                        {
                          f.total_used > 0 &&
                          <Label size="small" color="grey" circular title={`Used ${f.total_used} times`} className="label-left-floating">
                            { f.total_used }
                          </Label>
                        }
                        <Button
                          className={`file-btn w-100 ${authID === f.user_id ? 'owned' : ''}`}
                          basic
                          onDoubleClick={() =>
                            window.open(f.access_url, "_blank")
                          }
                        >
                          <div>
                            <div className="file-img">
                            {
                              f.thumbnail !== null
                                ? <img src={`https://d2a39xd6ecmbf2.cloudfront.net/drive/thumbnail/${f.thumbnail}`} height='150' width='250'/>
                                : <Icon name={getIconBasedOnFile(f.name)}/>
                            }
                            </div>
                            <div className="d-flex text-truncate file-name">
                              <Popup
                                trigger={
                                  <span className="text-truncate text-left">
                                    {f.name}
                                  </span>
                                }
                                inverted
                                hideOnScroll
                              >
                                <div>Name: {f.name}</div>
                                <div>
                                  Created At:
                                  {moment(f.created).format(
                                    " YYYY-MM-DD HH:mm:ss"
                                  )}
                                </div>
                                {f.modified && (
                                  <div>
                                    Last Modified At:
                                    {moment(f.modified).format(
                                      " YYYY-MM-DD HH:mm:ss"
                                    )}
                                  </div>
                                )}
                              </Popup>
                              <div className="folder-action">
                                <Dropdown
                                  key={`dropdown-${f.id}`}
                                  simple
                                  closeOnBlur
                                  closeOnEscape
                                  closeOnChange
                                  direction="left"
                                  icon={
                                    <Icon
                                      size="small"
                                      name="ellipsis vertical"
                                    />
                                  }
                                >
                                  <Dropdown.Menu>
                                    <Dropdown.Item
                                      onClick={() =>
                                        window.open(f.access_url, "_blank")
                                      }
                                    >
                                      <Icon name="arrow up" color="blue" />
                                      Open
                                    </Dropdown.Item>
                                    <Dropdown.Item onClick={() => {
                                      navigator.clipboard.writeText(f.access_url)
                                      this.setState({
                                        snackbar: {
                                          open: true,
                                          message: 'Copied to clipboard!',
                                          success: true,
                                          error: false
                                        }
                                      });
                                    }}>
                                      <Icon name="copy outline" color="blue"/>
                                      Copy Link
                                    </Dropdown.Item>
                                    <Dropdown.Item
                                      onClick={() =>
                                        downloadFile(f.access_url, f.name)
                                      }
                                    >
                                      <Icon name="download" color="blue" />
                                      Download
                                    </Dropdown.Item>
                                    <Dropdown.Item
                                      onClick={() =>
                                        this.setState({
                                          openDownloadAs: true,
                                          fileName: f.name,
                                          downloadURL: f.access_url,
                                        })
                                      }
                                    >
                                      <Icon name="download" />
                                      Download As
                                    </Dropdown.Item>
                                    {
                                      authID === f.user_id &&
                                      <>
                                        <Dropdown.Item
                                          onClick={() =>
                                            this.setState({editNamePopup: true, editName: f.name, fileForAction: f.id})
                                          }
                                        >
                                          <Icon name="edit" color="blue"/>
                                          Edit File
                                        </Dropdown.Item>
                                        <Dropdown.Item
                                          onClick={() =>
                                            this.setState({fileForAction: f.id, editName: f.name, openDeleteFile: true})
                                          }
                                        >
                                          <Icon name="trash alternate outline" color="red"/>
                                          Delete
                                        </Dropdown.Item>
                                      </>
                                    }
                                  </Dropdown.Menu>
                                </Dropdown>
                              </div>
                            </div>
                          </div>
                        </Button>
                      </GridColumn>
                    ))
                  ) : (
                    <div className="d-flex w-100 justify-content-center text-light">
                      No Files
                    </div>
                  )}
                </GridRow>
              </Grid>
            </div>
          </GridColumn>
        </Grid>
        <AddFolder
          addFolder={addFolder}
          folderLoading={assetsLoading}
          open={openAddFolder}
          parent={folderID}
					userID={authID}
          onClose={() => {
            this.setState({openAddFolder: false})
          }}
        />
        <AddFile
					open={openAddFile}
          fileLoading={assetsLoading}
          addFile={addFile}
          folderID={folderID}
					userID={authID}
          onClose={() => {
            this.setState({openAddFile: false})
          }}
        />
        <EditMedia
          assetType="clip"
          name={editName}
          open={editNamePopup}
          folderLoading={assetsLoading}
          fileLoading={assetsLoading}
          folderID={folderForAction}
          fileID={fileForAction}
          updateFolder={updateFolder}
          updateFile={updateFile}
          onClose={() => {
            this.setState({fileForAction: null, editName: null, folderForAction: null, editNamePopup: false})
          }}
        />
        <ConfirmModal
          open={openDeleteFolder}
          loading={assetsLoading}
          onCancelClick={() => this.setState({folderForAction: null, openDeleteFolder: false, editName: null})}
          onYesClick={this.confirmDeleteFolder}
          header={'Delete Folder'}
          primaryKey={`Folder ${editName}`}
        />
        <ConfirmModal
          open={openDeleteFile}
          loading={assetsLoading}
          onCancelClick={() => this.setState({fileForAction: null, openDeleteFile: false, editName: null})}
          onYesClick={this.confirmDeleteFile}
          header={'Delete File'}
          primaryKey={`File ${editName}`}
        />
        <DownloadAs
          open={openDownloadAs}
          onClose={() =>
            this.setState({
              openDownloadAs: false,
              fileName: null,
              downloadURL: null,
            })
          }
          fileName={fileName}
          fileURL={downloadURL}
        />
        <Snackbar
          open={snackbar.open}
          message={snackbar.message}
          error={snackbar.error}
          success={snackbar.success}
          onClose={this.resetSnackbar}
        />
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  files: state.assetsReducer.clipFileData,
  folders: state.assetsReducer.clipFolderData,
  assetsLoading: state.assetsReducer.loading,
  authID: state.authReducer.userID,
});

const mapDispatchToProps = {
  fetchClipAssetFile: getClipAssetFile,
  fetchClipFolder: getClipFolder,
  addFile: addClipAssetFile,
  addFolder: addClipFolder,
  updateFolder: editAssetFolder,
  updateFile: editAssetFile,
  deleteFile: deleteAssetFile,
  deleteFolder: deleteAssetFolder,
};

export default connect(mapStateToProps, mapDispatchToProps)(Clips);
